import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubstitutionAnnouncementsForm } from '../forms/SubstitutionAnnouncementsForm';

type SubstitutionAnnouncementsModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const SubstitutionAnnouncementsModal = ({ isOpen, onClose }: SubstitutionAnnouncementsModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal width='s' title={t('announcements.edit')} loading={loading} isOpen={isOpen} onRequestClose={onClose}>
      <SubstitutionAnnouncementsForm onLoad={setLoading} onClose={onClose} />
    </Modal>
  );
};
